import BlogRoutes from "../features/blog/routes/BlogRoutes";

function BlogPage() {
  return (
    <div className="bg-gradient-to-b from-blog to-customPurple-premium">
      <BlogRoutes />
    </div>
  );
}

export default BlogPage;
